import messages from '../locales/sk_SK.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'sk-SK',
};
export default lang;
